import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ScrollTop } from "@/components/ScrollTop";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Training from "@/pages/Training";
import Camps from "@/pages/Camps";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Register from "@/pages/Register";
import Waiver from "@/pages/Waiver";
import PayNow from "@/pages/PayNow";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App grain">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <AuthProvider>
          <BrowserRouter>
            <ScrollTop />
            <Routes>
              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
              <Route path="/training" element={<PublicLayout><Training /></PublicLayout>} />
              <Route path="/camps" element={<PublicLayout><Camps /></PublicLayout>} />
              <Route path="/faq" element={<PublicLayout><FAQ /></PublicLayout>} />
              <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
              <Route path="/register" element={<PublicLayout><Register /></PublicLayout>} />
              <Route path="/waiver/:regId" element={<PublicLayout><Waiver /></PublicLayout>} />
              <Route path="/pay/:regId" element={<PublicLayout><PayNow /></PublicLayout>} />
              <Route path="/payment/success" element={<PublicLayout><PaymentSuccess /></PublicLayout>} />
              <Route path="/payment/cancel" element={<PublicLayout><PaymentCancel /></PublicLayout>} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" />
        </AuthProvider>
      </ReactLenis>
    </div>
  );
}

export default App;
